import { render, staticRenderFns } from "./SupportLight.vue?vue&type=template&id=542090c4&"
import script from "./SupportLight.vue?vue&type=script&lang=js&"
export * from "./SupportLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports